(() => {
  // Cart page and cart drawer: shows the most common "Get it by" date once, keeps dates only on items that differ, and remembers whether the kit group is open.
  if (window.__chCart) return;
  window.__chCart = 1;
  const KEY = 'ch-kit-open';
  const store = {
    get() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } },
    set(v) { try { sessionStorage.setItem(KEY, v); } catch (e) { /* storage unavailable */ } }
  };

  const norm = el => el.textContent.replace(/\s+/g, ' ').trim();
  const clean = t => t.replace(/[<>&]/g, '');

  function syncDelivery(form) {
    const box = form.querySelector('[data-ch-delivery]');
    if (!box) return;
    const rows = [...form.querySelectorAll('[data-input-item]')];
    const pallet = rows.some(r => r.classList.contains('ch-is-pallet'));
    const dated = rows.filter(r => !r.classList.contains('ch-is-pallet')).map(r => ({row: r, el: r.querySelector('.gib-container')})).filter(d => d.el);
    if (dated.some(d => d.el.classList.contains('gib-loading'))) return;
    dated.forEach(d => { d.text = norm(d.el); });
    const counts = new Map();
    dated.forEach(d => { if (d.text) counts.set(d.text, (counts.get(d.text) || 0) + 1); });
    let common = '', best = 0;
    counts.forEach((n, t) => { if (n > best) { best = n; common = t; } });
    const useSummary = dated.length > 1 && best > 1;
    dated.forEach(d => {
      const isCommon = useSummary && d.text === common;
      if (d.row.classList.contains('ch-date-common') !== isCommon) d.row.classList.toggle('ch-date-common', isCommon);
      const isOther = useSummary && !!d.text && d.text !== common;
      if (d.row.classList.contains('ch-date-other') !== isOther) d.row.classList.toggle('ch-date-other', isOther);
    });
    const later = useSummary ? dated.filter(d => d.text && d.text !== common).length : 0;
    const lines = [];
    if (pallet) lines.push('<span><b>Free pallet delivery</b> for your aquarium · choose your date at checkout</span>');
    if (useSummary) {
      const label = later ? 'Most items: ' : (pallet ? 'Everything else: ' : '');
      lines.push(`<span><b>${label}${clean(common)}</b></span>`);
      if (later) lines.push(`<span>${later} item${later > 1 ? 's have' : ' has'} a different date · shown on ${later > 1 ? 'those items' : 'that item'} below</span>`);
    }
    const html = lines.join('');
    if (box.innerHTML !== html) box.innerHTML = html;
    if (box.hidden !== (lines.length === 0)) box.hidden = lines.length === 0;
  }

  function setupKit(form) {
    const kit = form.querySelector('[data-ch-kit]');
    if (!kit || kit.dataset.chReady) return;
    kit.dataset.chReady = '1';
    if (store.get() === '0') kit.open = false;
    kit.addEventListener('toggle', () => store.set(kit.open ? '1' : '0'));
  }

  // Hide the chat launcher while the cart drawer is open, so it never covers the drawer or the checkout button.
  const CHAT = '#gorgias-chat-container,#gorgias-web-messenger-container,#chat-button';
  function addChatStyle() {
    if (document.getElementById('ch-chat-hide')) return;
    const st = document.createElement('style');
    st.id = 'ch-chat-hide';
    st.textContent = CHAT.split(',').map(sel => `html.ch-cart-open ${sel},html.ch-bar-on ${sel}`).join(',') + '{display:none!important}';
    document.head.appendChild(st);
  }
  function drawerOpen() {
    const q = document.querySelector('.quick-cart');
    if (!q) return false;
    const qs = getComputedStyle(q);
    if (qs.display === 'none' || qs.visibility === 'hidden') return false;
    const c = q.querySelector('.quick-cart__container') || q;
    const cs = getComputedStyle(c);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    const r = c.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.left < window.innerWidth - 20 && r.right > 20;
  }
  function syncChat() {
    const open = drawerOpen();
    const root = document.documentElement;
    if (root.classList.contains('ch-cart-open') !== open) root.classList.toggle('ch-cart-open', open);
  }

  // Cart page on phones: the checkout bar stays fixed at the bottom until the full checkout section scrolls into view, so only one checkout button shows at a time.
  const mobile = window.matchMedia('(max-width: 760px)');
  let footerVisible = false;
  let footerWatched = null;
  function syncBar() {
    const form = document.querySelector('form.cart__form.ch-cart');
    const bar = form && form.querySelector('.ch-cart-bar');
    const footer = form && form.querySelector('.cart__footer');
    if (footer && footer !== footerWatched && 'IntersectionObserver' in window) {
      footerWatched = footer;
      const io = new IntersectionObserver(entries => {
        if (footer !== footerWatched) { io.disconnect(); return; }
        footerVisible = entries.some(e => e.isIntersecting);
        queue();
      });
      io.observe(footer);
    }
    const show = !!bar && mobile.matches && !footerVisible;
    if (bar && bar.classList.contains('is-hidden') === show) bar.classList.toggle('is-hidden', !show);
    const root = document.documentElement;
    if (root.classList.contains('ch-bar-on') !== show) root.classList.toggle('ch-bar-on', show);
  }

  let queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('form.ch-cart').forEach(form => { setupKit(form); syncDelivery(form); });
    syncChat();
    syncBar();
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  function init() {
    addChatStyle();
    run();
    // The drawer slides in, so check again once its animation finishes.
    document.addEventListener('transitionend', queue, true);
    document.addEventListener('animationend', queue, true);
    if (mobile.addEventListener) mobile.addEventListener('change', queue);
    // The drawer and cart page are re-rendered by the theme, so watch the whole page for new or updated cart forms.
    new MutationObserver(queue).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();